import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_shipment_aggregated_tasksService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentIds: number[], operationCodeIds?: number[], statusIds?: number[] }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, ShipmentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentIds)) {
      missingRequiredInParams.push('\'shipmentIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_shipment_aggregated_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentIds: number[], operationCodeIds?: number[], statusIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, ShipmentId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentIds)) {
      missingRequiredInParams.push('\'shipmentIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_shipment_aggregated_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentIds: number[], operationCodeIds?: number[], statusIds?: number[], $keys: { OperationCodeId?: number, StatusId?: number, ShipmentId?: number }[] }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, ShipmentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentIds)) {
      missingRequiredInParams.push('\'shipmentIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_shipment_aggregated_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentIds: number[], operationCodeIds?: number[], statusIds?: number[]    }) {
        if(isNil(inParams.shipmentIds)) {
          return true; 
        }
      return false;
    }
}
